import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ValidationLinkService } from '../../services/validation-link.service';
import { pathNames, variablePathNames } from '../../utilities/routing-path-utils';
import { MatIconModule } from '@angular/material/icon';
import { NgIf } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-validate-account-page',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    NgIf
  ],
  templateUrl: './validate-account-page.component.html',
  styleUrl: './validate-account-page.component.scss'
})
export class ValidateAccountPageComponent {
  email!: string;
  isLoading: boolean = false;

  constructor(private route: ActivatedRoute, private router: Router, private snackBar: MatSnackBar, private validationLinkService: ValidationLinkService){}

  ngOnInit(){
    this.email = this.route.snapshot.queryParamMap.get(variablePathNames.validateAccountPathVariable) || "";
  }

  onSendValidationLinkService(){
    this.isLoading = true;
    this.validationLinkService.sendAccountValidation(this.email).subscribe(() => {
      this.snackBar.open('email sent', 'Close');
      this.router.navigate(['/' + pathNames.loginPath]);
    });
  }
  
  onBackButton(){
    this.router.navigate(['/' + pathNames.loginPath]);
  }
}
